import { ReactElement } from 'react';
import { Navigate, PathRouteProps } from 'react-router';

// Hooks.
import { useAuth } from 'hooks';

export interface IAuthenticatedRouteProps extends PathRouteProps {
  requiresAuth?: boolean;
  requiresGuest?: boolean;
}

const AuthenticatedRoute = (props: IAuthenticatedRouteProps): ReactElement => {
  const { requiresAuth, requiresGuest, children } = props;
  const [, { isAuthenticated, isLoaded }] = useAuth();

  // Wait for auth to be loaded.
  if (!isLoaded) return null;

  // Redirect if conditions met.
  if (requiresAuth && !isAuthenticated) return <Navigate to="/401" />;
  if (requiresGuest && isAuthenticated) return <Navigate to="/" />;

  return <>{children}</>;
};

export default AuthenticatedRoute;
